<template>
  <div class="main">
    <div class="scroll-box" ref="scrollBox">
      <main class="content">
        <basic-info ref="basicInfoRef" v-model="basicInfoForm" :isModifying="true" :createdTime="createdTime"/>
        <template v-for="comItem in comList">
          <component 
            :is="dynamicComs[comItem.comType]" 
            :key="comItem.comId" 
            v-model="comItem.formData"
            :otherConf="otherConf"
            :isDit="true"
            :isHasSignUp="isHasSignUp"
            @changFoot="changFoot"
            :ref="comItem.comType"
            :basicInfoForm="basicInfoForm"
            :createdTime="createdTime"
          >
          </component>
        </template>
      </main>
    </div>
    <div class="footer" v-if="isFooter">
      <div class="footer-btn plain" @click="goBack">返回</div>
      <div class="footer-btn" @click="save">保存</div>
    </div>
  </div>
</template>

<script>
import BasicInfo from './components/basic-info'
import TopImage from './components/top-image'
import SignUp from './components/sign-up'
import Attention from './components/attention'
import ImageVideo from './components/image-video'
import Lottery from './components/lottery'
import LiveReserve from './components/live-reserve'
import Question from './components/question'
import Spike from './components/spike'
import ConnectPic from './components/connect-pic'
import GroupBuy from './components/group-buy'
import DrawLots from './components/drawLots'
import styleTest from './components/style-test'
import countMoney from './components/count-money'
import coupon from './components/coupon.vue'

import {isString} from '@/utils/utils'
import { 
  luckDrawData,
  paramesVerification,
  initspikeData,
  spikeTimeVerification,
  connectPicVerification,
  initGroupBuyingData
} from './utils'

export default {
  name: 'EditActivityBasic',
  components: {
    BasicInfo,
    TopImage,
    SignUp,
    Attention,
    ImageVideo,
    Lottery,
    Question,
    ConnectPic,
    GroupBuy,
    DrawLots,
    styleTest,
    countMoney,
    coupon
  },
  computed: {
     // 是否有报名项目
    isHasSignUp() {
      return this.comList.some(item => item.comType === 'sign-up');
    },
    // 是否有秒杀组件
    isSpike() {
      return this.comList.some(item => item.comType === 'spike');
    },
    // 是否有抽奖组件
    isLottery() {
      return this.comList.some(item => item.comType === 'lottery');
    },
    // 是否有拼图组件
    isConnectPic() {
      return this.comList.some(item => item.comType === 'connectPic');
    },
    is365() {
      return this.$cache.is365()
    }
  },
  data() {
    return {
      stepNum: 1,
      dynamicComs: {
        picture: TopImage,
        'sign-up': SignUp,
        'image-text-detail': ImageVideo,
        attention: Attention,
        'lottery': Lottery,
        'live-reserve': LiveReserve,
        'question' : Question,
        'spike': Spike,
        'connectPic': ConnectPic,
        'groupBuying': GroupBuy,
        'drawLots': DrawLots,
        'style': styleTest,
        "countMoney": countMoney,
        'coupon': coupon
      },
      // 模板包含的组件列表
      comList: [],
      basicInfoForm: {
        activityTitle: '',
        startTime: '',
        endTime: ''
      },
      activityId: '',
      otherConf: {
        isModifying: true
      },
      isFooter: true,
      createdTime: null
    }
  },
  methods: {
    async init() {
      const loading = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...',
      });
      await this.getActivityInfo();
      loading.clear();
    },
    // 初始化组件列表
    initComponentList(moduleList = []) {
      const comList = [];
      moduleList.forEach(moduleItem => {
        let formData = {};
        switch (moduleItem.moduleType) {
          case 'sign-up':
          case 'attention':
            moduleItem.activityModuleDetail.forEach(item => {
              // boolean类型的必须以is开头命名
              formData[item.moduleDetailCode] = isString(item.moduleDetailCode) && item.moduleDetailCode.startsWith('bool') 
                ? item.moduleDetailValue === 'true'
                : item.moduleDetailValue;
            })
            if (formData.customFieldStr) {
              formData.customField = JSON.parse(formData.customFieldStr)
            }
            break;
          case 'picture':
          case 'image-text-detail':
            formData = moduleItem.activityModuleDetail.map(item => ({
              moduleDetailId: item.moduleDetailId,
              moduleDetailValue: item.moduleDetailValue,
              detailDataType: item.detailDataType,
              sortNo: item.sortNo,
              remark: item.remark || ''
            }));
            break;
          case 'lottery': 
            formData = luckDrawData(moduleItem)
            break
          case 'live-reserve': 
            formData = this.liveReserveData(moduleItem)
            break
          case 'question': 
            formData.isHaslottery = moduleList.some(item => item.moduleType == 'lottery')
            break
          case 'spike': 
            formData.spikeSections = initspikeData(moduleItem).spikeSections
            break;
          case 'connectPic': 
            formData = moduleItem.connectPic
            formData.isLottery = moduleList.some(item => item.moduleType == 'lottery')
            break
          case 'groupBuying': 
            formData = initGroupBuyingData(moduleItem).groupBuyingVO
            break;
          case 'drawLots':
            formData = this.initDrawLotsData(moduleItem)
            break
          case 'style':
            formData = moduleItem.stylePageMain
            break
          case 'countMoney':
            formData = this.initCountMoneyData(moduleItem.gameModule)  
            break
          case 'coupon':
            formData = moduleItem.couponSessions 
            break
          default:
            break;
        }
        comList.push({
          comId: moduleItem.moduleId,
          comType: moduleItem.moduleType,
          sortNo: moduleItem.sortNo,
          formData
        });
      });
      this.comList = comList;
    },
    changFoot(param) {
      this.isFooter = param
    },
    getActivityInfo() {
      if (!this.$route.query.activityId) {
        return;
      }
      return this.$api.activityMgmt.getActivityEditDataById(this.$route.query.activityId)
        .then(({data}) => {
          if (!data) {
            return;
          }
          const {activityId, activityTitle, startTime, endTime, activityModuleEdit,createdTime = new Date().getTime()} = data;
          this.activityId = activityId;
          this.createdTime = createdTime
          this.basicInfoForm = {
            activityTitle,
            startTime,
            endTime
          };
          
          if (!Array.isArray(activityModuleEdit)) {
            return;
          }

          this.initComponentList(activityModuleEdit);
        })
        .catch(console.log);
    },
    goBack() {
      this.init()
      this.$router.go(-1);
    },
    // 注意事项参数, 图片，图文详情参数
    getComponentDTO(moduleItem, isImage) {
      const fields = [];
      if (isImage && Array.isArray(moduleItem.formData)) {
        moduleItem.formData.forEach(item => {
          fields.push({...item});
        });
      } else {
        for (const [key, value] of Object.entries(moduleItem.formData)) {
          if (key != 'customField') {
            fields.push({
              moduleDetailCode: key,
              moduleDetailValue: value
            });
          }
          
        }
      }

      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        activityModuleDetail: fields
      };
    },
    // 直播
    liveReserveData(moduleItem) {
      let formData = {}
      moduleItem.activityModuleDetail.forEach(item => {
        formData[item.moduleDetailCode] = item.moduleDetailValue
      })
      return formData
    },
    liveDataFormat(moduleItem) {
      const fields = []
      for(let [key,value] of Object.entries(moduleItem.formData)) {
        fields.push({
          moduleDetailValue: value,
          moduleDetailCode: key,
        })
      }
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        activityModuleDetail: fields
      }
    },
    spikeDataFormat(moduleItem) {
      moduleItem.formData.spikeSections.forEach(spikeSectionsItem => {
        if (spikeSectionsItem.spikeGoods) {
          spikeSectionsItem.spikeGoods.forEach(spikeGoodsItem => {
            spikeGoodsItem.headImg = spikeGoodsItem.headImgList[0].url
            if (spikeGoodsItem.detailsImg.length) {
              let detailsImg = []
              spikeGoodsItem.detailsImg.forEach(imgItem => {
                detailsImg.push(imgItem.url)
              })
              spikeGoodsItem.goodsDetails = detailsImg
            }
          })
        }
      })
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        spikeSections: moduleItem.formData.spikeSections,
      }
    },
    connectPicFormat(moduleItem) {
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        connectPic: moduleItem.formData,
      }
    },
    // 拼团
    groupBuyingFormat(moduleItem) {
      moduleItem.formData.goods.forEach(item => {
        item.headImg = item.headImgList[0].url
        if (item.detailsImg.length) {
          let goodsDetails = []
          item.detailsImg.forEach(imgItem => {
            goodsDetails.push(imgItem.url)
          })
           item.goodsDetails = goodsDetails
        }else {
          item.goodsDetails = []
        }
      })
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        groupBuying: moduleItem.formData,
      }
    },
    // 求签
    initDrawLotsData(moduleItem) {
       for(let [key,value] of Object.entries(moduleItem.drawLotsMain)) {
          if (key.startsWith('bool') && value != '') {
            moduleItem.drawLotsMain[key] = JSON.parse(value)
          }
       }
       return moduleItem.drawLotsMain
    },
    drawLotsFormat(moduleItem) {
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        drawLotsMain: moduleItem.formData,
      }
    },
     // 风格测试
    styleTestFormat(moduleItem) {
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        stylePageMain: moduleItem.formData,
      }
    },
    // 红包挑战赛
    initCountMoneyData(moduleItem) {
      let fieldS = ['awardSet','rankingType','rule']
      for (let [key,value] of Object.entries(moduleItem)) {
        if ((value && key.startsWith('bool') || fieldS.includes(key))) {
          moduleItem[key] = JSON.parse(value)
        }
      }
      return moduleItem
    },
    countMoneyFormat(moduleItem) {
      let fieldS = ['awardSet','rankingType','rule']
      let newFormData = _.cloneDeep(moduleItem.formData)
      for (let [key,value] of Object.entries(newFormData)) {
        if ((value && fieldS.includes(key))) {
          newFormData[key] = JSON.stringify(value)
        }
      }
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        gameModule: newFormData,
      }
    },

    // 优惠券组件
    couponFormat(moduleItem) {
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        couponSessions: moduleItem.formData,
      }
    },
    async save() {
      const basicInfoRef = this.$refs.basicInfoRef;
      if (basicInfoRef && !basicInfoRef.checkValid()) {
        return ;
      }
       // 报名字段验证
      if (this.isHasSignUp){
        let isPass = true
        this.comList.forEach(item => {
          if (item.comType == 'sign-up') {
            item.formData.customFieldStr = JSON.stringify(item.formData.customField)
            if (item.formData.boolSmsSet) {
              if (item.formData.smsText == '') {
                this.$toast('请输入报名成功的短信内容')
                isPass = false
              }
            }
            let fieldIsPass = item.formData.customField.every(fieldItem => fieldItem.fieldKey != '')
            if (!fieldIsPass) {
              this.$toast('请输入报名自定义字段')
              isPass = false
            }
          }
        })
        if (!isPass) {
          return
        }
      }
       // 问答必填项验证
      if (this.$refs.question) {
        const verification = await this.$refs.question[0].onFailed().catch(_=>(console.log(_)))
        if (!verification) {
          return 
        }
      }
      if (this.isSpike) {
        const {isAdopt,title} = paramesVerification(this.comList, 'spike')
        if (!isAdopt) {
          this.$toast(title)
          return
        }else {
          const data = spikeTimeVerification(this.comList, 'spike', this.basicInfoForm)
          if (!data.timeAdopt) {
            this.$toast(data.title)
            return
          }
        }
      }

      // 拼图参数验证
      if (this.isConnectPic) {
        const isAdopt = connectPicVerification(this.comList)
        if (!isAdopt) {
          this.$notify({
            message: `请完善拼图设置`,
            type: 'warning'
          });
          return
        }
      }
      // 拼团参数验证
      if (this.$refs.groupBuying) {
        let isAdopt = await this.$refs.groupBuying[0].submit().catch(_=>(console.log(_)))
        if (!isAdopt) {
          return
        }
      }
      // 求签参数验证
      if (this.$refs.drawLots) {
        if (!this.$refs.drawLots[0].verifyDrawLots()) {
          return
        }
      }
      // 风格测试参数验证
      if (this.$refs.style) {
        if (!this.$refs.style[0].verifyParames()) {
          return
        }
      }
      // 红包挑战赛
      if (this.$refs.countMoney) {
        await this.$refs.countMoney[0].verifyParames()
      }

      // 优惠券组件
      if (this.$refs.coupon) {
        const isPass = await this.$refs.coupon[0].verifyParames()
        if (!isPass) return
      }

      const activityModule = [];
      this.comList.forEach(item => {
        switch (item.comType) {
          case 'sign-up':
          case 'attention':
            activityModule.push(this.getComponentDTO(item));
            break;
          case 'picture':
          case 'image-text-detail':
            activityModule.push(this.getComponentDTO(item, true));
            break;
          case 'lottery':
            activityModule.push(this.getLiveReserveDTO(item, true));
            break; 
          case 'live-reserve':
            activityModule.push(this.liveDataFormat(item, true));
            break;
          case 'question':
            activityModule.push(this.liveDataFormat(item, true));
            break;
          case 'spike':
            activityModule.push(this.spikeDataFormat(item, true));
            break;
          case 'connectPic':
            activityModule.push(this.connectPicFormat(item, true));
            break;
          case 'groupBuying':
            activityModule.push(this.groupBuyingFormat(item, true));
            break;
          case 'drawLots':
            activityModule.push(this.drawLotsFormat(item, true));
            break;
          case 'style':
            activityModule.push(this.styleTestFormat(item));
            break;
          case 'countMoney':
            activityModule.push(this.countMoneyFormat(item));
            break;
          case 'coupon':
            activityModule.push(this.couponFormat(item));
            break;
          default:
            break;
        } 
      });
      const params = {
        flag: this.is365 ? 2 : 1,
        activityId: this.activityId,
        ...this.basicInfoForm,
        // 组件
        activityModule,
      };
      this.$api.activityMgmt.editActivity(params)
        .then(() => {
          this.$toast('保存成功');
          this.$router.go(-1);
        })
        .catch(err => {
          console.log(err);
        })
    },
    // 抽奖组件
    getLiveReserveDTO(moduleItem) {
      const fields1 = [];
      moduleItem.formData.prizeList.forEach(item => {
        let discharge = ['moduleGroupCode','isNewAdd','fieldId','isReplace']
        for(let [key, value] of Object.entries(item)) {
          if (!discharge.includes(key)) {
            fields1.push({
              moduleDetailCode: key,
              moduleDetailValue: key == 'bakImg' && item[key].length ? item[key][0].url :  value ? value.toString() : '',
              moduleGroupCode: item.moduleGroupCode
            })
          }
        }
      })
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        activityModuleDetail: fields1,
      };
    },
  },
  created() {
    this.init();
  },
  mounted() {
    // 监听抽奖组件删除保存成功
    this.bus.$on('handleSuccess',()=> {
      this.init()
    })
  }
}
</script>

<style lang="stylus" scoped>
.main
  .scroll-box
    height: calc(100vh - 64px)
    overflow-y auto
    &::-webkit-scrollbar
      display: none
    
  .footer
    box-sizing: border-box
    position fixed
    left 0
    bottom 0
    // z-index 999
    padding 0 10px
    height 64px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    background-color #fff

    .footer-btn
      padding 10px 50px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    .footer-btn-s
      padding 10px 15px
    .plain
      color $mainTextColor
      background-color: #fff

</style>
